import { jsx as _jsx } from "react/jsx-runtime";
import { createReactWrapper } from '../common/PrefixUtils';
import { handleForwardRef } from '../common/RefUtils';
import { forwardRef, useEffect, useRef, useState } from 'react';
import { LegacyTooltipV3 } from './LegacyTooltipV3.shell';
export const TooltipV3 = forwardRef((props, ref) => {
    const tooltipV3Ref = useRef();
    const handledRef = handleForwardRef(tooltipV3Ref, ref);
    const [isNativePopoverVersion] = useState(() => {
        var _a;
        const t = document.createElement('chameleon-tooltip-v3');
        return (_a = t.isNativePopoverVersion) !== null && _a !== void 0 ? _a : false;
    });
    const handleToggle = (event) => {
        var _a, _b;
        const toggleEvent = event;
        const evt = new CustomEvent(event.type, {
            detail: { isOpen: toggleEvent.newState === 'open' },
        });
        try {
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, evt);
        }
        catch (_c) {
            console.log('Error in onChange event');
        }
        try {
            (_b = props.onToggle) === null || _b === void 0 ? void 0 : _b.call(props, toggleEvent);
        }
        catch (_d) {
            console.log('Error in onToggle event');
        }
    };
    useEffect(() => {
        var _a;
        (_a = tooltipV3Ref.current) === null || _a === void 0 ? void 0 : _a.addEventListener('toggle', handleToggle);
        return () => {
            var _a;
            (_a = tooltipV3Ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('toggle', handleToggle);
        };
    }, [ref, props.onChange]);
    if (isNativePopoverVersion) {
        return createReactWrapper({
            tagName: 'chameleon-tooltip-v3',
            props: Object.assign(Object.assign({}, props), { 'trigger-id': props.triggerId, 'is-open': props.isOpen, 'min-width': props.minWidth, 'max-width': props.maxWidth, 'z-index': props.zIndex, ref: handledRef }),
            children: props.children,
        });
    }
    return _jsx(LegacyTooltipV3, Object.assign({}, props, { ref: handledRef }));
});
